import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import getEnv, { Environment } from '../../utils/environment';

const cache = new InMemoryCache();

const SHOPIFY_STORE_DOMAIN =
  process.env.NEXT_PUBLIC_SHOPIFY_DOMAIN || '0prqvu-0y.myshopify.com';
const SHOPIFY_STOREFRONT_TOKEN =
  // biome-ignore lint/style/noNonNullAssertion: Automated migration to Biome
  process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_TOKEN!;

// Documentation and version information https://shopify.dev/docs/api/storefront?version=2025-04
const API_VERSION = '2025-04';
export const STOREFRONT_ENDPOINT = `https://${SHOPIFY_STORE_DOMAIN}/api/${API_VERSION}/graphql.json`;
const env = getEnv();

const createStorefrontApolloClient = () => {
  const httpLink = new HttpLink({
    uri: STOREFRONT_ENDPOINT,
    headers: {
      'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_TOKEN,
      'Content-Type': 'application/json',
    },
  });

  const isTestEnv = env !== Environment.PROD;

  const client = new ApolloClient({
    link: httpLink,
    cache: cache,
    devtools: { enabled: isTestEnv },
    defaultOptions: {
      watchQuery: {
        errorPolicy: 'all',
      },
      query: {
        errorPolicy: 'all',
      },
    },
  });

  return client;
};

export default createStorefrontApolloClient;
